var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-spinner"},[_c('div',{staticClass:"ldio-nmj5gn45h1"},[_c('div'),_c('div')])])
}]

export { render, staticRenderFns }